<template>
  <div
    class="flex-1 flex flex-col max-w-full overflow-x-hidden shadow-xl bg-white dark:bg-neutral-900 text-black dark:text-white">
    <div v-for="(row, i) in rows" :key="`row${i}`">
      <template v-if="row.is_full_width">
        <div v-for="m in row.modules" :key="`module${m.id}`">
          <component v-if="m.module.full_width_only" :is="m.module.component" :data="m.data" :office-id="m.office_id" />
          <template v-else>
            <div class="container mx-auto">
              <component :is="m.module.component" :data="m.data" :office-id="m.office_id" />
            </div>
          </template>
        </div>
      </template>
      <div v-else class="container mx-auto">
        <div class="flex flex-wrap items-center justify-center">
          <div v-for="m in row.modules" :key="`module${m.id}`" class="w-full">
            <component :is="m.module.component" :data="m.data" :office-id="m.office_id" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextModule from './modules/TextModule.vue'
import ImageModule from './modules/ImageModule.vue'
import VideoModule from './modules/VideoModule.vue'

export default {
  components: {
    TextModule,
    ImageModule,
    VideoModule
  },
  props: {
    supplier: {
      type: Object,
      required: true
    }
  },
  computed: {
    rows () {
      let output = []

      let newRow = null
      for (let i = 0; i < this.supplier.modules.length; i++) {
        if (!newRow || newRow.is_full_width !== this.supplier.modules[i].is_full_width) {
          if (newRow) {
            output.push(newRow)
          }
          newRow = { is_full_width: this.supplier.modules[i].is_full_width, modules: [] }
        }
        newRow.modules.push(this.supplier.modules[i])
      }
      if (newRow) {
        output.push(newRow)
      }

      return output
    }
  },
  methods: {
  }
}
</script>
